module.exports = __webpack_public_path__ + "static/media/Eye.5dfd4f92.svg";